if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.buttonType = this.dataset.buttonType || 'anchor';
      this.addToCartBtn = this.querySelector('.sticky-atc-panel__add-to-cart-btn');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      if (this.buttonType === 'add_to_cart' && this.addToCartBtn) {
        this.addToCartBtn.addEventListener('click', this.handleAddToCart.bind(this));
        this.syncButtonState();
        // Listen for variant changes to update button state
        const variantPicker = this.productSection.querySelector('variant-picker');
        if (variantPicker) {
          variantPicker.addEventListener('on:variant:change', this.syncButtonState.bind(this));
        }
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }

    /**
     * Syncs the sticky panel button state with the main form button
     */
    syncButtonState() {
      if (!this.addToCartBtn || !this.productForm) return;

      const mainSubmitBtn = this.productForm.querySelector('[name="add"]');
      if (!mainSubmitBtn) return;

      // Sync disabled state
      this.addToCartBtn.disabled = mainSubmitBtn.disabled;
      if (mainSubmitBtn.disabled) {
        this.addToCartBtn.setAttribute('aria-disabled', 'true');
      } else {
        this.addToCartBtn.removeAttribute('aria-disabled');
      }

      // Sync text content
      this.addToCartBtn.textContent = mainSubmitBtn.textContent.trim();
    }

    /**
     * Handles add to cart button click
     */
    handleAddToCart(evt) {
      if (!this.productForm || !this.addToCartBtn) return;
      if (this.addToCartBtn.disabled || this.addToCartBtn.getAttribute('aria-disabled') === 'true') return;

      const form = this.productForm.querySelector('.js-product-form');
      const submitBtn = this.productForm.querySelector('[name="add"]');

      if (form && submitBtn) {
        // Trigger the form submission by clicking the actual submit button
        // This ensures all form validation and handlers are properly executed
        submitBtn.click();
      }
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
